export enum PaymentModality {
  'debit' = 'debit',
  'transfer' = 'transfer',
  'check' = 'check',
}
